import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp } from 'lucide-react';

import type { CropPan } from './photo-crop';
import { KEY_STEP } from './use-crop-gestures';

const clampUnit = (v: number) => Math.min(1, Math.max(0, v));

export interface PhotoNudgeButtonsProps {
  /** Which ways the photo can move: false for a direction with no spare photo to reveal. */
  canMoveSideways: boolean;
  canMoveUpDown: boolean;
  phone: boolean;
  setPan: (update: (pan: CropPan) => CropPan) => void;
}

/** Four buttons that move the photo a little, for anyone who cannot or would rather not drag. */
export function PhotoNudgeButtons({
  canMoveSideways,
  canMoveUpDown,
  phone,
  setPan,
}: PhotoNudgeButtonsProps) {
  const size = phone ? 44 : 26;
  const moves = [
    { label: 'Move photo up', Icon: ChevronUp, dx: 0, dy: -KEY_STEP, enabled: canMoveUpDown },
    { label: 'Move photo down', Icon: ChevronDown, dx: 0, dy: KEY_STEP, enabled: canMoveUpDown },
    { label: 'Move photo left', Icon: ChevronLeft, dx: -KEY_STEP, dy: 0, enabled: canMoveSideways },
    {
      label: 'Move photo right',
      Icon: ChevronRight,
      dx: KEY_STEP,
      dy: 0,
      enabled: canMoveSideways,
    },
  ];
  return (
    <div
      role="group"
      aria-label="Move the photo"
      style={{ display: 'flex', gap: 6, color: 'var(--nb-muted)' }}
    >
      {moves.map(({ label, Icon, dx, dy, enabled }) => (
        <button
          key={label}
          type="button"
          className="nb-btn"
          aria-label={label}
          disabled={!enabled}
          onClick={() => setPan((pan) => ({ x: clampUnit(pan.x + dx), y: clampUnit(pan.y + dy) }))}
          style={{
            width: size,
            height: size,
            padding: 0,
            justifyContent: 'center',
            color: 'inherit',
          }}
        >
          <Icon size={14} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
